import React from "react";

interface BlockButtonProps {
  text?: string;
  onClick: () => void;
  dataTestId?: string;
  disabled?: boolean;
  isReplace?: boolean;
}

const BlockButton = ({ text, onClick, dataTestId, disabled, isReplace }: BlockButtonProps) => {
  return (
    <button disabled={disabled} className={isReplace ? 'replace-block-button' :  disabled ? 'block-button-disabled' : 'block-button'} data-testid={dataTestId} onClick={onClick}>
      {text}
    </button>
  );
};

export default BlockButton;
